
const LocationSection = () => {
  const handleWhatsApp = () => {
    window.open('https://wa.me/905422671171?text=Merhaba%20ben%20lhglobalpass.com%20%C3%BCzerinden%20ileti%C5%9Fime%20ge%C3%A7iyorum', '_blank');
  };

  const handleCall = () => {
    window.location.href = 'tel:+905422671171';
  };

  return (
    <section className="bg-navy text-white py-20">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Column */}
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold mb-6">
              Ofisimize Bekleriz
            </h2>
            <p className="text-gray-300 text-base mb-8 leading-relaxed">
              Fevzi Paşa Mah. 847/1 Sk. No:8 Kat:4 Daire:4/405
              <br />
              Sağlık İş Hanı, Konak/İzmir
            </p>

            {/* Contact Info */}
            <div className="space-y-5 mb-10">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-gold rounded-full">
                  <i className="ri-phone-line text-navy text-xl"></i>
                </div>
                <a href="tel:+905422671171" className="text-white hover:text-gold transition-colors duration-300">
                  +90 542 267 11 71
                </a>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-gold rounded-full">
                  <i className="ri-mail-line text-navy text-xl"></i>
                </div>
                <a href="mailto:lhglobalpass@gmail.com" className="text-white hover:text-gold transition-colors duration-300">
                  lhglobalpass@gmail.com
                </a>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={handleWhatsApp}
                className="bg-gold hover:bg-gold-dark text-navy px-8 py-4 rounded-full text-base font-semibold transition-all duration-300 hover:shadow-lg flex items-center justify-center gap-2 whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                WhatsApp ile İletişim
              </button>
              <button
                onClick={handleCall}
                className="bg-transparent border-2 border-white hover:bg-white text-white hover:text-navy px-8 py-4 rounded-full text-base font-semibold transition-all duration-300 hover:shadow-lg flex items-center justify-center gap-2 whitespace-nowrap"
              >
                <i className="ri-phone-line text-xl"></i>
                Hemen Ara
              </button>
            </div>
          </div>

          {/* Right Column - Map */}
          <div>
            <div className="rounded-2xl overflow-hidden border-2 border-white/20 shadow-2xl h-[400px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3125.4892847392847!2d27.126487!3d38.419200!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14bbd862a0000000%3A0x0!2zMzjCsDI1JzA5LjEiTiAyN8KwMDcnMzUuNCJF!5e0!3m2!1str!2str!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="LH Global Pass Ofis Konumu"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
